import React from "react";
import { T } from "../../../traks";
import { Container, Row, Col } from "reactstrap";
import { SummaryRow } from "./SummaryRow";
import {
  determineExtraOptionName,
  determinePackageDescription,
  determinePackageName
} from "./CartUtils";
import { formatDate, formatPrice } from "../Globals/GlobalUtils";

export const CartPackageItem = ({
  line,
  setView,
  defaultCurrency,
  handleRemove
}) => {
  return (
    <React.Fragment>
      <h4 className="mb-4">
        <T>Thank you for choosing Aktiedysten</T>
      </h4>

      <Container>
        <Row className="justify-content-between">
          <Col lg="6" md="6" sm="6">
            <SummaryRow
              icon="https://static.aktiedysten.dk/gfx/present-icon-pink-29-07-2025.png"
              label={<T>Package choice</T>}
              value={1}
              bold={true}
              extraDetails={determinePackageName(line.packageId)}
              itemDescription={determinePackageDescription(line.packageId)}
            />

            <SummaryRow
              icon="https://static.aktiedysten.dk/gfx/user-icon-green-2023-0.svg"
              label={<T>Invitations</T>}
              value={line.keys}
              bold={true}
            />

            <SummaryRow
              icon="/gfx/calendar-color-0.svg"
              label={<T>Months</T>}
              value={line.months}
              bold={true}
            />

            <SummaryRow
              icon="/gfx/calendar-color-0.svg"
              label={<T>Add‑ons</T>}
              value={1}
              bold={true}
              extraDetails={determineExtraOptionName(line.extraOptionId)}
            />

            <SummaryRow
              icon="/gfx/calendar-color-0.svg"
              label={<T>Start date</T>}
              value={formatDate(new Date(line.startDate))}
              bold={true}
            />

            <SummaryRow
              icon="/gfx/calendar-color-0.svg"
              label={<T>Premium valid until</T>}
              value={formatDate(new Date(line.expirationDate))}
              bold={true}
            />

            <div className="mt-2">
              <b><T>Price:</T>&nbsp;</b>
              <span>
                {formatPrice(line.discountedTotal)} {defaultCurrency}&nbsp;
              </span>
              <span className="checkout-price-no-vat">
                (
                {formatPrice(line.discountedTotalNoVat)} {defaultCurrency}
                &nbsp;<T>excl. VAT</T>)
              </span>
            </div>
          </Col>

          <Col xs="auto" className="text-right">
            <Row className="mb-2">
              <a
                role="button"
                className="mr-2"
                onClick={() => setView("order")}
              >
                <img
                  className="cart-icon"
                  src="/gfx/gear-icon-0.svg"
                  alt="Edit"
                />
                <T>Edit</T>
              </a>
            </Row>
            <Row>
              <a role="button" className="mr-2" onClick={handleRemove}>
                <img
                  className="cart-icon"
                  src="/gfx/remove-portfolio-icon-1.svg"
                  alt="Remove"
                />
                <T>Remove</T>
              </a>
            </Row>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Cart/CartPackageItem.js